import { InterviewSubmitProps } from "components/tasks/interviews/FormInterviewTask";
import {
  InterviewFormParameters,
  InterviewFormFields,
  InterviewFormMessages,
} from "components/tasks/interviews/interviewApiTypes";
import { SubmitHandler } from "react-hook-form";
import { TaskComponentProps } from "components/tasks/taskHelpers";
import SupervisorNameForm from "./SupervisorNameForm";
import { useStoreTaskMutation } from "tasks/taskQueries";
import TaskSpinnerOverlay from "components/common/basic/TaskSpinnerOverlay";

export type SupervisorNameApiForm = {
  formFields: SupervisorNameApiFormFields;
  formMessages: InterviewFormMessages;
  formParameters: InterviewFormParameters;
};

export interface SupervisorNameFormFields {
  supervisorsName?: string;
  supervisorsTitle?: string;
  doSave?: boolean;
}

interface SupervisorNameApiFormFields extends InterviewFormFields {
  supervisorsName?: string;
  supervisorsTitle?: string;
}

interface SupervisorNameTaskProps extends TaskComponentProps {
  applicationUid: string;
  taskId: string;
  form: SupervisorNameApiForm;
  onSubmit?: SubmitHandler<InterviewSubmitProps>;
  isSavable?: boolean;
}

export default function SupervisorNameTask({
  applicationUid,
  taskId,
  form,
  onSubmit,
  isSavable = true,
  goToStatusCheck,
}: SupervisorNameTaskProps): JSX.Element {
  const { isLoading: isStoring, variables } = useStoreTaskMutation({
    taskId,
    onSuccess: goToStatusCheck,
  });

  const formFields = {
    supervisorsName: form.formFields?.supervisorsName || "",
    supervisorsTitle: form.formFields?.supervisorsTitle || "",
  };

  const formMessages = {
    formName: form.formMessages?.formName || "",
  };

  const formParameters = {
    formId: form.formParameters?.formId || "",
    formType: form.formParameters?.formType || "",
  };

  return isStoring ? (
    <TaskSpinnerOverlay isStoring={isStoring} saveOnly={variables?.saveOnly} />
  ) : (
    <SupervisorNameForm
      defaultValues={{
        [formParameters.formId]: {
          supervisorsName: formFields.supervisorsName,
          supervisorsTitle: formFields.supervisorsTitle,
        },
      }}
      formMessages={formMessages}
      formParameters={formParameters}
      isSavable={isSavable}
      onSubmit={onSubmit}
      goToStatusCheck={goToStatusCheck}
    />
  );
}
